var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"bg-info text-light mt-4"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('h6',[_vm._v("© "+_vm._s(new Date().getFullYear()))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }